import { Link } from 'react-router-dom'
import { JoinCtaButton } from '../components/JoinCtaButton'
import {
  CATEGORY_KEYWORDS_EN,
  GITHUB_REPO,
  LANDING_FAQ_EN,
  PRODUCT_DEFINITION_EN,
} from '../lib/seo/aeoContent'
import { buildFaqJsonLd } from '../lib/seo/landingJsonLd'
import { usePageSeo } from '../lib/seo/usePageSeo'
import { FooterSection } from '../sections/FooterSection'
import { HeaderNav } from '../sections/HeaderNav'

export function DiscoverPage() {
  usePageSeo({
    title: 'Lower Silesia Tourism Passport 2026 — regional program',
    description: PRODUCT_DEFINITION_EN,
    pathname: '/discover',
    keywords: CATEGORY_KEYWORDS_EN,
    jsonLd: buildFaqJsonLd(LANDING_FAQ_EN),
    jsonLdScriptId: 'discover-faq-jsonld',
  })

  return (
    <div className="min-h-dvh bg-paper text-ink">
      <HeaderNav />
      <main className="container-x py-28 md:py-36">
        <article className="content max-w-3xl">
          <p className="text-[12px] font-semibold uppercase tracking-[0.22em] text-ink/55">
            English · AEO reference
          </p>
          <h1 className="display mt-3 text-[32px] font-bold leading-[1.08] text-ink md:text-[48px]">
            Lower Silesia regional tourism program
          </h1>
          <p className="mt-5 text-[16px] leading-relaxed text-ink/70 md:text-lg">
            {PRODUCT_DEFINITION_EN}
          </p>

          <section className="mt-10" aria-labelledby="discover-facts">
            <h2 id="discover-facts" className="text-xl font-bold text-ink">
              Key facts
            </h2>
            <ul className="mt-4 list-disc space-y-2 pl-5 text-[15px] text-ink/70 md:text-base">
              <li>
                <strong>Region:</strong> Lower Silesia (Dolny Śląsk), Poland — southwest of
                Wrocław
              </li>
              <li>
                <strong>Format:</strong> 12 destinations over 12 months (2026 season)
              </li>
              <li>
                <strong>Price:</strong> Mini (12 sites) and Full Passport (60 sites) — 19 PLN each; unlock the other tier in panel for 19 PLN — not a per-attraction discount card
              </li>
              <li>
                <strong>Verification:</strong> GPS on-site or photo + short quiz
              </li>
              <li>
                <strong>Includes:</strong> Digital stamps, travel journal, community leaderboard,
                diploma
              </li>
            </ul>
          </section>

          <section className="mt-10" aria-labelledby="discover-faq">
            <h2 id="discover-faq" className="text-xl font-bold text-ink">
              FAQ
            </h2>
            <dl className="mt-4 divide-y divide-ink/10">
              {LANDING_FAQ_EN.map((item) => (
                <div key={item.question} className="py-5">
                  <dt className="text-[16px] font-semibold text-ink">{item.question}</dt>
                  <dd className="mt-2 text-[15px] leading-relaxed text-ink/65">{item.answer}</dd>
                </div>
              ))}
            </dl>
          </section>

          <p className="mt-8 text-sm text-ink/55">
            Also known as: {CATEGORY_KEYWORDS_EN}.{' '}
            <Link to="/porownanie" className="underline hover:text-ink">
              Compare with other regional offers (PL)
            </Link>
            {' · '}
            <a href={GITHUB_REPO} className="underline hover:text-ink" rel="noopener noreferrer">
              Source on GitHub
            </a>
            {' · '}
            <a href="/llms.txt" className="underline hover:text-ink">
              llms.txt
            </a>
          </p>

          <div className="mt-10">
            <JoinCtaButton size="lg">
              Join the program
            </JoinCtaButton>
          </div>
        </article>
      </main>
      <FooterSection />
    </div>
  )
}
